export const RATING = [5, 4, 3, 2, 1, 0];

export const formatWavePeriodValue = (dateValue = new Date()) =>
  `${dateValue.getFullYear()}${String(dateValue.getMonth() + 1).padStart(2, '0')}`;

export const DEFAULT_STATS_TABS = ['DAILY', 'MONTHLY', 'WAVE'];

// Set once the low-credits alert has been shown: it survives a reload, and the login page clears it,
// so the alert comes once per login.
export const CREDITS_ALERT_SHOWN_FLAG = 'creditsAlertShown';

export const CHANNEL_TYPES = {
  Short: 0,
  Long: 1,
};

export const formatThousands = (num) => {
  if (!num) return '0';
  return num.toLocaleString()?.replace(',', '.');
};
